import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TickerBand from "./components/TickerBand";
import HotRank from "./components/HotRank";
import GodComments from "./components/GodComments";
import SceneZones from "./components/SceneZones";
import QuoteWall from "./components/QuoteWall";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <TickerBand />
      <HotRank />
      <GodComments />
      <SceneZones />
      <QuoteWall />
      <Faq />
      <Footer />
    </main>
  );
}